var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{ name: 'cookingCheckInput', params: {menuId:_vm.menuId,subMenuId:_vm.subMenuId} }}},[_vm._v(_vm._s(_vm.lowerButtonName))])}
var staticRenderFns = []

export { render, staticRenderFns }